module.exports = __webpack_public_path__ + "img/search-no-result.fec30250.jpg";